import "../src/styles/main.scss";
import React from "react";
// Zmieniliśmy BrowserRouter na HashRouter tutaj:
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Practice from "./components/Practice";
import Exam from "./components/Exam";
import QuestionList from "./components/QuestionList";
import { ExamProvider } from "./context/ExamContext";
import { Home } from "./components/Home";
import { WithBackButton } from "./components/WithBackButton";

const App = () => {
  return (
    <Router>
      <ExamProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/practice"
            element={<WithBackButton component={<Practice />} />}
          />
          <Route
            path="/exam"
            element={<WithBackButton component={<Exam />} />}
          />
          <Route
            path="/questions"
            element={<WithBackButton component={<QuestionList />} />}
          />
        </Routes>
      </ExamProvider>
    </Router>
  );
};

export default App;